import { render, staticRenderFns } from "./DailyCheckFreeComment.vue?vue&type=template&id=5f50441e&"
import script from "./DailyCheckFreeComment.vue?vue&type=script&lang=js&"
export * from "./DailyCheckFreeComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports